module.exports = __webpack_public_path__ + "img/residencia-1.80b9019d.png";